<div role="dialog" aria-labelledby="dialogTitle" >
  <div class="modal-header">
    <h4 id="dialogTitle" role="header" class="modal-title module-title">{{"plan.settings"|translate}}</h4>
    <button [disabled]="!_enableCancel" type="button" value="Close" class="close" aria-label="Close" (click)="dismiss()" title="{{'dialog.box.close.tooltip'|translate}}">
      <span class="icon-Close" aria-hidden="true"></span>
    </button>
  </div>
  <div class="modal-body">
    <wfm-plan-loading-overlay *ngIf="_isLoading"></wfm-plan-loading-overlay>
    <div class="col-16">
      <form [formGroup]="planSettingsForm" (submit)="submit()">
        
        <div>
          <div class="row">
            <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10'>
              <label class="text-uppercase input-label">
                {{"plan.settings.patience.time.title" | translate}}
              </label>
            </div>
          </div>
          <div class="row">
            <div class='col-sm-12'>
                <div class="checkbox sm-left-pad">
                  <input type="checkbox" formControlName="usePatienceTime" id="patienceTimeSetting" name="patienceTime" value="enable" (change)="onUsePatienceTime($event)">
                  <label for="patienceTimeSetting">{{"plan.settings.patience.time.checkbox" | translate}}</label>
                  <span class="inline-input">
                    <p-inputnumber formControlName="medianPatienceTime"
                      mode="decimal"
                      [useGrouping]="false"
                      [maxlength]="_maxLenMpt"
                      name="patienceTimeInput"
                      inputId="patienceTimeInput"
                      styleClass="mpt-input"
                      autocomplete="off"
                      (onInput)="mptOnInput($event)"
                    >
                    </p-inputnumber> {{"plan.settings.unit.seconds" | translate}}
                  </span>
                  <span tooltipStyleClass="ui-tooltip-bright"  class="info-tooltip" placement="right" ngbPopover="{{'plan.settings.patience.time.tooltip' | translate}}" popoverClass="popover-tooltip" container="body" triggers="mouseenter:mouseleave:click" [openDelay]="300"><i class="icon-info"></i></span>
                </div>
                <div *ngIf="_showPatienceTimeValidationError" class="error-message">{{'validation.err.patience.time.input'|translate}}</div>
            </div>
          </div>
          <div class="row">
            <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10'>
              <label class="text-uppercase input-label patience">
                {{"plan.settings.calculation.mode.title" | translate}}
              </label>
            </div>
          </div>
          <div class="row">
            <div class='col-sm-12'>
              <div>
                <div class="radio">
                  <input type="radio" formControlName="ctDistributionCalcMethod" name="ctDistributionCalcMethod" id="MUToCT" value="MU_CT_DISTRIBUTION" >
                  <label for="MUToCT">
                    {{"plan.settings.mu.ct.dist" | translate}}
                  </label>
                  <span tooltipStyleClass="ui-tooltip-bright"  class="info-tooltip" placement="right" ngbPopover="{{'plan.settings.mu.ct.dist.tooltip' | translate}}" popoverClass="popover-tooltip" container="body"  triggers="mouseenter:mouseleave:click" [openDelay]="300"><i class="icon-info"></i></span>
                </div>
                <div class="radio">
                  <input type="radio" formControlName="ctDistributionCalcMethod" name="ctDistributionCalcMethod" id="FTERequired" value="FTE_REQUIRED">
                  <label for="FTERequired">
                    {{"plan.settings.fte.required" | translate}}
                  </label>
                  <span tooltipStyleClass="ui-tooltip-bright"  class="info-tooltip" placement="right" ngbPopover="{{'plan.settings.fte.required.tooltip' | translate}}" popoverClass="popover-tooltip" container="body" triggers="mouseenter:mouseleave:click" [openDelay]="300"><i class="icon-info"></i></span>
                </div>


              </div>
            </div>
          </div>
          <div class="row">
            <div class='col-sm-12'>
              <div class="embedded-warning patience" [ngClass]="{'invisible':!displayFTEWarning}">
                <i class="fa fa-warning"></i>
                {{"plan.settings.fte.required.warning" | translate}}
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer">
    <div class="modal-buttons">
      <breeze-button buttonText="{{'plan.cancel.btn'|translate}}"
                     id="cancel-btn"
                     [showTooltip]="false"
                     [isSecondary]="true"
                     [isDisabled]="!_enableCancel"
                     (clicked)="dismiss()"></breeze-button>

      <breeze-button buttonText="{{'plan.submit.btn'|translate}}"
                     id="accept-btn"
                     [showTooltip]="false"
                     [isPrimary]="true"
                     [isDisabled]="!_enableAccept"
                     (clicked)="submit()"></breeze-button>
    </div>
  </div>
</div>
<p-toast position="bottom-center">
</p-toast>
